/**
 * Custom JavaScript - MegaMartOnline
 *
 * Hooks disponiveis:
 * document.addEventListener('variant:changed', function(event) { var variant = event.detail.variant; });
 * document.addEventListener('product:added', function(event) { var variant = event.detail.variant; var quantity = event.detail.quantity; });
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 */

/* FIX: scroll handler com throttle (evita execucao em cada pixel de scroll) */
if (window.matchMedia("(max-width: 768px)").matches) {
  var _scrollTimer = null;
  window.addEventListener('scroll', function() {
    if (_scrollTimer) return;
    _scrollTimer = setTimeout(function() {
      _scrollTimer = null;
      var pageOffset = window.scrollY,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
    }, 100);
  }, { passive: true });
}

window.addEventListener('load', function() {
  requestAnimationFrame(function() {
    var btn = document.querySelector('.footer__block-item.footer__block-item--links:nth-child(2) button');
    if (btn) btn.click();
  });
});


/* Lazy loading para imagens da descricao do produto (rich text) */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.rte img, .product-description img').forEach(function(img) {
    if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    }
  });
});


$(".block-swatch__radio, .variant-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

function increaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  document.getElementById('number').value = value;
}

function decreaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value < 1 ? value = 1 : '';
  value--;
  document.getElementById('number').value = value;
}

/* FIX: codigo do kit/opcoes so roda se existir na pagina */
if ($('.options').length) {
  $('.options:first-child').addClass('active');

  $(".options").each(function(index) {
      $(this).on("click", function(){
        $('.options.active .selector-desconto').text($('.options.active .selector-desconto').attr('cup'))
        $('.options').removeClass('active')
        $(this).addClass('active')
        $('.options.active .selector-desconto').append(' APLICADO')
        $('.precode').remove()
        $('.price--compare').remove()
        $('.price-list').append('<p class="precode">' + $(this).find('.valortot span').text() + '</p>')
        $('.price').text($(this).find('.valortot b').text())

        $('.price .selector-desconto').remove()

        var cupom = $('.options.active .selector-desconto').text()

        if(cupom != '')
        $('.price').append('<p class="selector-desconto">' + cupom + '</p>')

        setTimeout(function(){ parcelamento2() }, 100);
      });
  });

  $(".options").each(function( index ) {
    var valor = parseFloat($(this).find('.valorunico b').text().replace('R$ ', '').trim())
    var menor = $('.options:first-child .valorunico b').text().replace('R$ ', '').replace(',', '.').trim()
    var result = ((valor - menor)*100 / valor) * (-1);
    var porcenta = 'CUPOM ' + result.toFixed(0).replace('.', ',') + '% OFF'
    $(this).find('.selector-desconto').attr('cup', porcenta )
    $(this).find('.selector-desconto').text(porcenta)
  });
}

/* Botao comprar (kit) - so roda se o botao existir */
if ($('.botaocmprar').length) {
  $(".product-form").each(function () {
      $(this).on('click', '.botaocmprar', function (event) {
          var arraydeprodutos = [];
          event.stopImmediatePropagation();
          var idproduto = parseInt($('.options.active .iddavariante').attr('val'))
          var qtdproduto = parseInt($('.options.active .iddavariante').attr('qtd'))
          arraydeprodutos.push({
              id: idproduto,
              quantity: qtdproduto
          });

          data = {
              items: arraydeprodutos
          }
          $.ajax({
              type: 'POST',
              url: '/cart/add',
              data: data,
              dataType: 'json',
              success: function (data) {
                  setTimeout(function () {
                      window.location.href = '/cart'
                  }, 500);
              }
          });
      });
  });
}
